module.exports = __webpack_public_path__ + "static/media/02.f863b05d.mp3";